import gql from 'graphql-tag'
import Signup from '~/models/signup'

export interface CreateSignupResponse {
  createSignup: Signup
}

export interface CreateSignupVars {
  organization_code: string
  organization_name: string
  user_name: string
  email: string
  password: string
}

export const CREATE_SIGNUP = gql`
  mutation CreateSignup (
    $organization_code: String
    $organization_name: String
    $user_name: String
    $email: String
    $password: String
  ) {
    createSignup (
      organization_code: $organization_code
      organization_name: $organization_name
      user_name: $user_name
      email: $email
      password: $password
    ) {
      id
      organization_code
      organization_name
      user_name
    }
  }
`

export interface ActivateSignupResponse {
  activateSignup: Signup
}

export interface ActivateSignupVars {
  verify_token: string
}

export const ACTIVATE_SIGNUP = gql`
  mutation ActivateSignup (
    $verify_token: String
  ) {
    activateSignup (
      verify_token: $verify_token
    ) {
      organization_code
    }
  }
`